import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, ConnectedComponent, useSelector } from 'react-redux';
import {
	CarlineSelect,
	InputError,
	InputGroupWrapper,
	InputWrapper,
	Matricula,
	TextInputExtended,
} from 'src/components';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { CitaFormDataFields } from 'src/forms/CitaPosventa/types';
import { OneFormState } from 'src/types';
interface MatriculaAnoMatriculacionModeloProps {
	formData: CitaFormDataFields;
	paginaConfirmacion?: boolean;
	paddingTop?: string;
	paddingBottom?: string;
}

const MatriculaAnoMatriculacionModelo = (
	props: MatriculaAnoMatriculacionModeloProps,
) => {
	const { register, errors } = useFormContext();
	const { error, setError } = useOneFormContext();
	const [inputValueAno, setInputValueAno] = useState('');
	const [pristineMatricula, setPristineMatricula] = useState(true);
	const [pristineAno, setPristineAno] = useState(true);
	const [errorMatricula, setErrorMatricula] = useState(false);
	const [errorAno, setErrorAno] = useState(false);
	const regExpAno = /^(19|20)\d{2}$/;
	const [regExCounty, setRegExCounty] = useState<RegExp[]>(null);
	const { formData, paginaConfirmacion } = props;

	useEffect(() => {
		if (formData.anoMatriculacion) {
			setInputValueAno(formData.anoMatriculacion);
			setPristineAno(false);
		}
	}, []);

	const handleChangeAno = (e: any) => {
		setInputValueAno(e.target.value);
		setPristineAno(false);
	};

	useEffect(() => {
		if (inputValueAno.length < 4) {
			return;
		} else {
			if (!pristineAno && inputValueAno.match(regExpAno) === null) {
				setErrorAno(true);
			} else if (inputValueAno === '') {
				setPristineAno(true);
				setErrorAno(false);
			} else {
				setErrorAno(false);
			}
		}
	}, [inputValueAno, pristineAno]);

	useEffect(() => {
		if (error) {
			errorAno || pristineAno ? setErrorAno(true) : setErrorAno(false);
			errorMatricula || pristineMatricula
				? setErrorMatricula(true)
				: setErrorMatricula(false);
		}
	}, [error]);

	useEffect(() => {
		if (!errorMatricula && !errorMatricula) setError(false);
	}, [errorMatricula, errorMatricula]);

	const { formInfo } = useSelector((state: OneFormState) => state);

	const fields = (
		<>
			<Matricula />

			<InputWrapper
				className="ano_matricula-input-wrapper"
				notALayer={formInfo.notALayer}
				paddingTop={paginaConfirmacion ? '0' : null}
			>
				<TextInputExtended
					name="anoMatriculacion"
					label="Año de matriculación"
					type="number"
					innerRef={register({
						required: {
							value: true,
							message: 'Requerido',
						},
						pattern: {
							value: regExpAno,
							message: 'Ejemplo: 2010',
						},
					})}
					isFloating
					onChange={e => handleChangeAno(e)}
					required
				/>
				{errorAno && (
					<InputError className="input-error">
						Ejemplo: 2010
					</InputError>
				)}
			</InputWrapper>

			<CarlineSelect paddingTop={paginaConfirmacion ? '0' : null} />
		</>
	);

	return paginaConfirmacion ? (
		fields
	) : (
		<InputGroupWrapper
			className="matricula_modelo-group-wrapper"
			paddingTop={paginaConfirmacion ? '0' : null}
		>
			{fields}
		</InputGroupWrapper>
	);
};

const mapStateToProps = (state: OneFormState) => {
	return {
		formInfo: state.formInfo,
		formData: state.formData.fields,
	};
};

const ConnectedComponent = connect(mapStateToProps)(
	MatriculaAnoMatriculacionModelo,
);

export { ConnectedComponent as MatriculaAnoMatriculacionModelo };
